import { Component, OnInit, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import { Location } from '@angular/common';
import { FormControl } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TableData } from '../md/md-table/md-table.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../services/user.service';
import { User } from '../models/user';
import { ContactHistoryService } from '../services/contacthistory.service';
import { ReminderService } from '../services/reminder.service';
import { Reminder } from '../models/reminder';
import { ContactHistory } from '../models/contacthistory';
import { CompanylinkedService } from '../services/companylinked.service';
import { CompanyLinked } from '../models/companylinked';
import { Holydays } from '../models/holydays';
import { ContactsFormService } from '../services/contactsform.service';
import { UserTagService } from '../services/user-tag.service';
import { CategoriesService } from '../services/categories.service';
import { HolidaysService } from '../services/holidays.service';
import { LocationService } from '../services/location.service';
import { TermService } from '../services/saleterm.service';
import { ConditionService } from '../services/condition.service';
import { CurrencyService } from '../services/currency.service';
import { VendorService } from "../services/vendor.service";
import { Methods } from '../shared/methods';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import swal from 'sweetalert2';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Cell, DinamicData } from '../models/dinamic-data';
import { ConfigService } from '../services/config.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {POService} from "../services/po.service";
import { GuiGuard } from '../shared/guard/base-gui-guard';
import { ManagePermissionsComponent } from './manage-permissions/manage-permissions.component';

declare const require: any;

declare const $: any;

interface FileReaderEventTarget extends EventTarget {
  result: string;
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}

export interface UserList {
  value: string;
  name: string;
}

@Component({
  selector: 'app-paciente-cmp',
  templateUrl: 'paciente.component.html',
  styleUrls: ['../customers/nuevo-cliente/nuevo-cliente.component.css', './paciente.component.scss'],
  providers: [
    UserService,
    ContactHistoryService,
    CompanylinkedService,
    ReminderService,
    UserTagService,
    CategoriesService,
    HolidaysService,
    LocationService,
    TermService,
    GuiGuard,
    ConditionService,
    CurrencyService,
    VendorService
  ]
})

export class PacienteComponent implements OnInit, AfterViewInit {
  public mtds: Methods = new Methods();
  public buscando = false;
  public holydasy: string[][];
  public hdStart = '';
  public hdEnd = '';
  public hdComments = '';
  public hdAvailability = true;
  public loadingHd = false;
  public cargando = false;
  public guardando = false;
  public action = 'create';
  public identity;
  public token;
  public privilegio;
  public holydays: Holydays;
  public savingHd = false;
  public tableContacts: TableData;
  public availablePaidHours: number = 0;
  public totalUsedHours: number = 0;
  public welcomeSent: number = 1;
  public mobiletempo;
  public editCompany: boolean = false;

  public groupsList: any[] = [];
  public companyLocations: any[] = [];
  isMobile: boolean = false;
  public loading;
  public seletedaddress = 1 ;
  // public contacts;
  public contacts: Array<ContactHistory>;

  public idUser;
  public rating = 1;
  public ratingResponse = 1;
  public ratingPayment = 1;
  public ratingeasy = 1;
  starCount: number = 5;
  color: string = 'accent';
  ratingArr = [];
  public user: User;
  isEditing: boolean = false;
  isSelectDisabled: boolean = true;
  // public user;

  public companies: Array<CompanyLinked>;
  public pages;
  public pagePrev;
  public pageNext;
  public filter = 0;
  public order = 0;
  public searchString;
  public status_user;
  public urlProfilePic = 'https://www.datalus.mx/projects/liposser/resources/uploads/default-avatar.png';
  public companySelected;
  public usersTags = [];
  reps: any[] = [];
  selectedRep;
  public locationSelected;
  public locations: any[] = [];
  public termSelected;
  public terms: any[] = [];
  public conditionSelected;
  public conditions: any[] = [];
  public currencySelected;
  public currencies: any[] = [];
  public warehouseList;
  public activos = 1;
  public allCategories;
  public categories: any[] = [];
  public userCategories: number[] = [];
  public vendorStatus:boolean = false;
  public permissionStatus = false; 

  sexos = [
  { value: 0, viewValue: 'Female' },
    { value: 1, viewValue: 'Male' },
    { value: 2, viewValue: 'Other' }
  ];

  frequencies = [
    { value: 'DAILY', viewValue: 'Daily' },
    { value: 'WEEKLY', viewValue: 'Weekly' },
    { value: 'MONTHLY', viewValue: 'Monthly' },
    { value: 'NEVER', viewValue: 'Never' },
  ];

  public deptos = [
    { value: 'SALESREP', viewValue: 'Sales' },
    { value: 'MANIFESTDEPARTMENT', viewValue: 'Manifest' },
    { value: 'RECEIVINGDEPARTMENT', viewValue: 'Receiving' },
    { value: 'TECHREP', viewValue: 'Tech' },
  ]

  public contacthistory: ContactHistory;
  selectedFile: File;
  public statusHolyday: any = null;
  isFormEnabled: boolean = false;

  public optionSelectMenuTrigger: string;
  listStatus: { icon: string, iconColor:string, value: string, label: string }[]  = [
    { icon: 'circle', iconColor: '#DCDEE1 !important', value: 'Inactive', label: 'Inactive'},
    { icon: 'circle', iconColor: '#008141 !important', value: 'Active', label: 'Active'},
  ]
  constructor(

    public dialog: MatDialog, private _userService: UserService,
    private _tagServices: UserTagService,
    private _contactHistoryService: ContactHistoryService,
    private _reminderService: ReminderService,
    private _companylinkedService: CompanylinkedService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _cattegorieServices: CategoriesService,
    private _hdServices: HolidaysService,
    private _locationService: LocationService,
    private _termService: TermService,
    private _conditionService: ConditionService,
    private _currencyService: CurrencyService,
    private _vendorService: VendorService,
    private location: Location,
    private _poService: POService,
    public guard: GuiGuard,
    private breakpointObserver: BreakpointObserver,
    public dialogToManagePermissions: MatDialog
  ) {
    this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    });

    this.user = new User();
    this.companySelected = 0;
    this.locationSelected = 0;
    this.termSelected = 0;
    this.conditionSelected = 0;
    this.currencySelected = 0;
    this.privilegio = JSON.parse(localStorage.getItem('privilegio'));
    console.log(this.privilegio);
    console.log(this.privilegio.level);
    if (this.privilegio.level === 'VENDOR') {
      this._router.navigate(['/dashboard']);
    }
    this.identity = this._userService.getIdentity();
    console.log(this.identity);
    if (this.identity == null) {
      localStorage.clear();
      this._router.navigate(['/pages/lock']);
    }
    this.token = this._userService.getToken();
    this._route.params.forEach((params: Params) => {
      this.idUser = + params['id'];
/*       this._userService.getUser(this.token, this.idUser).subscribe(data => {
        this.user = data;
        this.rating = this.user.customerPricing;
        this.ratingResponse = this.user.customerResponseTime;
        this.ratingPayment = this.user.customerPaymentOnTime;
        this.ratingeasy = this.user.customerEasyToWorkWith;
      }); */
      // console.log("iduser: " + this.idUser );
    });
    this.holydays = new Holydays(this.identity.sub);
    this.canCreate();

  }

  // ------------------------ Manage Permissions - Start --------------------------
  showDetails(): void {
    const dialogRef = this.dialogToManagePermissions.open(ManagePermissionsComponent, {
      data: {userId: this.idUser},
      width: "500px",
      height: '60%' 
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  // ------------------------ Manage Permissions - End --------------------------

  toggleForm() {
    this.isFormEnabled = !this.isFormEnabled;
  }
  Customertrigger(newValue: string){
    this._userService.deleteUser(this.token, this.idUser).subscribe(
      (response) => {
        console.log(response);
        if (response.status === "success") {
          this.showToast('success',  this.activos === 1 ? 'Customer status has been changed to inactive' : 'Customer status has been changed to active', 2000)
          /* this.mtds.notifySuccess(
            this.activos === 1
              ? "Customer status has been changed to customer"
              : "Customer status has been changed to active"
          ); */
        } else {
          this.showToast('error', 'An error occurred while entering to change the status of this user', 2000)
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
  menuTriggerToShow(newValue: string) {
    /* if (newValue === "Active") { this.activos = 0; } else { this.activos = 1 }
    this.cambiarActivos() */

    this._vendorService.activeVendor(this.idUser).subscribe(
      (r) => {
        if (r.status === "success") {
          this.showToast('success',  this.activos === 1 ? 'Vendor status has been changed to inactive' : 'Vendor status has been changed to active', 2000)
          /* this.mtds.notifySuccess(
            this.activos === 1 ? 'Vendor status has been changed to inactive' : 'Vendor status has been changed to active'
          ); */
        } else {
          this.optionSelectMenuTrigger = 'Inactive';
          this.showToast('error', r.msg, 4000)
        }
      }, error => {
        this.showToast('error', 'An error occurred while entering to change the status of this user', 2000)
      }
    );
  }
  //ratingicon
  showIcon(index: number): string {
    return this.rating > index ? 'star' : 'star_border';
}

showIconResponse(index: number): string {
    return this.ratingResponse > index ? 'star' : 'star_border';
}

showIconPayment(index: number): string {
    return this.ratingPayment > index ? 'star' : 'star_border';
}

showIconEasy(index: number): string {
    return this.ratingeasy > index ? 'star' : 'star_border';
}


canCreate() {
  try {
    let st: any = this.guard.permissions("inventory-client"); 
    console.log('Valor retornado por permissions: ', st);

    if (st === undefined || st === null) {
      console.error('El valor de st es inválido: ', st);
      return;
    }

    // Verificar si 'st' es una cadena antes de intentar parsear
    if (typeof st === 'string') {
      try {
        // Solo parsear si la cadena no está vacía ni es 'undefined'
        if (st.trim() !== '' && st !== 'undefined') { 
          st = JSON.parse(st);
        } else {
          console.error('La cadena de st está vacía o no es JSON válido:', st);
          return;
        }
      } catch (jsonError) {
        console.error('Error al analizar JSON en permissions: ', jsonError);
        return;
      }
    }

    // Finalmente, convertir el resultado en un valor booleano
    this.permissionStatus = !!st;

  } catch (e) {
    console.log('Error en canCreate: ', e);
  }
}


/*   showIcon(index:number) {
    if (this.rating >= index + 1) {
      return 'star';
    } else {
      return 'star_border';
    }
  }

  showIconResponse(index: number): string {
    return index < this.ratingResponse ? 'star' : 'star_border';
  }

  showIconPayment(index: number): string {
    return index < this.ratingPayment ? 'star' : 'star_border';
  }

  showIconEasy(index: number): string {
    return index < this.ratingeasy ? 'star' : 'star_border';
  } */
/*   clickstarResponse(rating){
    this.ratingResponse = rating;
    this.user.customerResponseTime = rating;
  }
  clickstarPayment(rating){
    this.ratingPayment = rating;
    this.user.customerPaymentOnTime = rating;
  }
  clickstarEasy(rating){
    this.ratingeasy = rating;
    this.user.customerEasyToWorkWith = rating; 
  }




  clickstar(rating){
    this.rating = rating;
    this.user.customerPricing = rating; 
  } */
  clickstar(rating: number) {
    this.rating = this.rating === rating ? 0 : rating;
    this.user.customerPricing = this.rating;
}

clickstarResponse(rating: number) {
    this.ratingResponse = this.ratingResponse === rating ? 0 : rating;
    this.user.customerResponseTime = this.ratingResponse;
}

clickstarPayment(rating: number) {
    this.ratingPayment = this.ratingPayment === rating ? 0 : rating;
    this.user.customerPaymentOnTime = this.ratingPayment;
}

clickstarEasy(rating: number) {
    this.ratingeasy = this.ratingeasy === rating ? 0 : rating;
    this.user.customerEasyToWorkWith = this.ratingeasy;
}
/*   ChangeRepBtton(){
    console.log(this.selectedRep)
    console.log(this.reps)
    console.log(this.user.managedByString)
    
  } */
  //
  startEditing() {
    this.isEditing = true;
    this.isSelectDisabled = false;
  }
  saveChanges() {
    console.log(this.user)
    this.isEditing = false;
    this.isSelectDisabled = true;
    
    const payload = {
      user: this.user.id,
      new_user: this.selectedRep.id
    };
    this._userService.changerep(this.token, payload).subscribe(
      response => {
        if (response.status === 'success') {
          this.showToast('success', 'Representative changed successfully', 2000)
        } else {
          this.showToast('error', 'Error changing representative.', 2000)
        }
      },
      error => {
        console.log(error);
        alert("An error occurred");
      }
    );
  }
  cancelEditing() {
    this.isEditing = false;
    this.isSelectDisabled = true;
    // Aquí puedes implementar la lógica para deshacer cambios si es necesario
  }
  GetRep(){
      this._userService.getAllUsersLite(this.token, "exceptuser").subscribe(
        response => {
        if (response.status == 'success') {
          this.reps = response.data;
/*           const rep:any = this.reps.find(r => r.id === this.user.managedBy);
          if (rep!= undefined) {
            this.selectedRep = rep;
          }else{
            const rep2:any = this.reps.find(r => r.name+' '+r.surname === this.user.managedByString );
            this.selectedRep = rep2;
          } */
          this.getDATAREP();
          } else {
           
  
          }
         
        });
  }
  getDATAREP(){
     this._userService.getAllUsersLite(this.token, "exceptuserincludeinactive").subscribe(
        response => {
        if (response.status == 'success') {
          const rep:any = this.reps.find(r => r.id === this.user.managedBy);
          if (rep!= undefined) {
            this.selectedRep = rep;
          }else{
            const rep2:any = this.reps.find(r => r.name+' '+r.surname === this.user.managedByString );
            this.selectedRep = rep2;
          }

          } else {
           
  
          }
         
        });
  }
  ngOnInit() {
    if(this.user.locationId == null){
      this.user.locationId == 1
    }
    for (let index = 0; index < this.starCount; index++) {
      this.ratingArr.push(index);
    }
    this.GetRep();
    this.optionSelectMenuTrigger='Active';

    console.log(this.user)
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(['/pages/lock']);
    } else {
      this.getUser();
      this.getCompanies();
      this.getAllContacts();
      this.getHolydays();
      this.getLocations();
      this.getTerms();
      this.getConditions();
      this.getCurrencies();
      this.getWarehouse();
      this.GetRep();
    }
    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);
      console.log(this);
      if (input[0].files && input[0].files[0]) {
        const reader = new FileReader();
        console.log('estamos cambiando');
        reader.onload = function (e: any) {
          $('#wizardPicturePreview').attr('src', reader.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    this.getUsersRoles();
    this.getStatusVendor();
  }


getStatusVendor(): void {
  this._poService.getVendorStatus(this.token, this.idUser).subscribe(
    r => {
      if (r.status === 'success') {
        // Asegúrate de que r.data[0] contiene el objeto esperado
        const vendorData = r.data[0];  // Asumiendo que la respuesta es un array y estás tomando el primer objeto
        if (vendorData.enableInventory === 1) {
          this.vendorStatus = true;
        } else {
          this.vendorStatus = false;
        }
      } else {
        console.error('Error en la respuesta del estado del vendedor');
      }
    },
    error => {
      console.error('Error al obtener el estado del vendedor', error);
    }
  );
}

  goBack(): void {
    this.location.back();
  }

  getCompanyLocations(company_id) {
    this._locationService.getLocationsByCompany(this.token, company_id).subscribe(
      r => {
        console.log(r);
        this.companyLocations = r.data;
      }
    );
  }

  changeCompany() {
    let flat = false;
    console.log(this.companySelected);
    console.log(this.companies);

    this._companylinkedService.getCompany(this.token, this.companySelected).subscribe(
      async r => {
        console.log(r);
        this.user.companyLinked = r.data;
        this.user.locationId = null;
        await this.getCompanyLocations(this.user.companyLinked.id);
        await this.changeLocation();
      }
    );
  }

//
OpenContactH(): void {
  let dialogRef = this.dialog.open(ContactHistoryComponent, {
    width: '950px',
    data: { userid: this.user }
  });
  dialogRef.afterClosed().subscribe(result => {
 
 
  });
}
//
openChangePasswordDialog(): void {
  let dialogRef = this.dialog.open(UserChangePasswordComponent, {
    width: '650px',
    data: { userid: this.user }
  });
  dialogRef.afterClosed().subscribe(result => {
 
 
  });
}
showToast(type, title, timer) {
  const Toast = swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: timer,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = swal.stopTimer;
      toast.onmouseleave = swal.resumeTimer;
    }
  })
  Toast.fire({
    icon: type,
    title: title
  });
}
//
  openModalResetMFA() {
    swal.fire({
      title: '',
      text: 'Are you sure you want to Reset Multi Factor Authenticator ?',
      icon:'info',
      showCancelButton: true,
      buttonsStyling: false,
  
      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(function (result) {
      if (result.value) {
        this.saveMFA();
      }
    }.bind(this));
   /*  $('#modalMFA').modal('show'); */
  }

  saveMFA(){

    let json = {
      resetmfa: this.user.id
    }

    this._userService.phoneAuthentication(json).subscribe(
      (response) => {

        if(response.status === 'success'){

          $('#modalMFA').modal('hide');
          this.showToast('success', 'Multi Factor Authenticator has been reset correctly', 2000)
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  activeVendor(id, active) {
  
    swal.fire({
      title: '',
      text: 'Do you want to make this vendor ' + (active === 1 ? 'inactive' : 'active'),
     
      showCancelButton: true,
      buttonsStyling: false,
  
      customClass:{
    confirmButton: 'btn btn-warning',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(function (result) {
      if (result.value) {
        this._vendorService.activeVendor(id).subscribe(
          r => {
            if (r != null) {
              this.getUser();
              this.mtds.notifySuccess(
                active === 1 ? 'Vendor status has been changed to inactive' : 'Vendor status has been changed to active'
              );
            }
          }, error => {
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
      }
    }.bind(this));
  }

  changeLocation() {
    let flat = false;
   
    this.user.typeLocationSelected = 'Headquarter';
    if (this.user.locationId != null && this.user.locationId != 0) {
      console.log(this.companyLocations)
      console.log(this.user.locationId);
      for (let loc of this.companyLocations) {
        if (this.user.locationId == loc.id) {
          console.log(loc.address);
          this.user.address = loc.address;
          this.user.address2 = loc.address2;
          this.user.country = loc.country;
          this.user.colonia = loc.colonia;
          this.user.city = loc.city;
          this.user.zipCode = loc.zipCode;
          this.user.phone = loc.phone;
          this.user.mobilePhone = loc.mobilePhone;
          flat = true;
          break;
        }
      }
      this.user.typeLocationSelected = 'Location';
    } else if (this.user.locationId == 0) {
      
      this.user.typeLocationSelected = 'Blank';

      this.user.address = '';
      this.user.address2 = '';
      this.user.country = '';
      this.user.colonia = '';
      this.user.city = '';
      this.user.zipCode = '';
      this.user.phone = '';
      this.user.mobilePhone = '';

      flat = true;
    }

    if (!flat) {
      console.log(this.user.companyLinked);
      this.user.address = this.user.companyLinked.address;
      this.user.address2 = this.user.companyLinked.address2;
      this.user.country = this.user.companyLinked.country;
      this.user.colonia = this.user.companyLinked.colonia;
      this.user.city = this.user.companyLinked.city;
      this.user.zipCode = this.user.companyLinked.zipCode;
      this.user.phone = this.user.companyLinked.phone;
      if(this.user.companyLinked.mobilePhone === ""){
        this.user.mobilePhone = this.mobiletempo;
      }else{
        this.user.mobilePhone = this.user.companyLinked.mobilePhone;
      }
    }
  }
  

  getUsersRoles() {

    this._userService.getUsersRoles(this.token).subscribe(
      response => {
        let group;

        if (response.code == 400) {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        }

        for (group of response.data) {
          if (group.role != 'customer' && group.role != 'VENDOR') {
            let item: any;
            let name = group.role;
            switch (name) {
              case 'CLERICALREP':
                name = "CLERICAL REP";
                break;
              case 'PURCHASINGREP':
                name = "PURCHASING REP";
                break;
              case 'RECEIVINGDEPARTMENT':
                name = "RECEIVING DEPARTMENT";
                break;
              case 'MANIFESTDEPARTMENT':
                name = "MANIFEST DEPARTMENT";
                break;
              case 'SALESREP':
                name = "SALES REP";
                break;
              case 'SHIPPINGREP':
                name = "SHIPPING REP";
                break;
              case 'TECHREP':
                name = "TECH REP";
                break;
              case 'WAREHOUSEREP':
                name = "WAREHOUSE REP";
                break;
            }
            item = {
              id: group.role,
              name: name
            };
            this.groupsList.push(item);
          }
        }
      }
    );
  }

  changeCompanyName() {
    this.editCompany = true;
    setTimeout(function () {
      $("#companyName").focus();
    }, 50);
  } 

  isRep() {
    return (this.identity.role === 'ADMINISTRATOR' || this.identity.role.includes('REP'));
  }

  getWarehouse() {

    this._locationService.getLocations(this.token).subscribe(
      response => {
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          this.warehouseList = response.data;
        } else {
          //this.showSwal('error', 'ERROR!', response.msg);
        }
        this.loading = false;
      },
      error => {
        console.log(<any>error);
        this.showSwal('error');
        this.loading = false;
      }
    );

  }

  getLocations() {
    this._locationService.getLocationsByUser(this.token, this.idUser).subscribe(
      response => {
        console.log(response);
        if (response.status == 'success') {
          this.locations = response.data;
        } else {
          console.log("Error");
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  getTerms() {
    this._termService.getTermsByUser(this.token, this.idUser).subscribe(
      response => {
        console.log(response);
        if (response.status == 'success') {
          this.terms = response.data;
        } else {
          console.log("Error");
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  getConditions() {
    this._conditionService.getConditionsByUser(this.token, this.idUser).subscribe(
      response => {
        console.log(response);
        if (response.status == 'success') {
          this.conditions = response.data;
        } else {
          console.log("Error");
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  getCurrencies() {
    this._currencyService.getCurrenciesByUser(this.token, this.idUser).subscribe(
      response => {
        console.log(response);
        if (response.status == 'success') {
          this.currencies = response.data;
        } else {
          console.log("Error");
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  msgeSwal(type, title = '', message = '') {
    if (type === 'success') {
      swal.fire({
     
        title: title,
        text: message,
        buttonsStyling: false,
       customClass:{
    confirmButton: 'btn btn-success'
            },
      });
    } else if (type === 'error') {
      swal.fire({
      
        title: 'ERROR!',
        text: title,
        buttonsStyling: false,
       customClass:{
    confirmButton: 'btn btn-success'
            },
      });
    }
  }

  openFormModal() {
    this.holydays = new Holydays(this.identity.sub);
    $('#hdFormModal').modal('show');
  }

  closeFormModal() {
    $('#hdFormModal').modal('hide');
  }

  shorTime(time) {
    let hora = Number(time[0] + time[1]);
    let minutos = Number(time[2] + time[3]);
    let m = 'AM';
    if (hora >= 12) {
      m = 'PM';
    }
    if (hora > 12) {
      hora = hora - 12;
    }

    let horaString;
    let minutosString;

    if (hora < 10) {
      horaString = '0' + hora;
    } else {
      horaString = String(hora);
    }

    if (minutos < 10) {
      minutosString = '0' + minutos;
    } else {
      minutosString = String(minutos);
    }

    return horaString + ':' + minutosString + ' ' + m;
  }

  getHolydays() {
    this.loadingHd = true;
    this._hdServices.showAll(this.idUser).subscribe(
      response => {
        console.log('Holydays!!');
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          let element;
          this.holydasy = [];
          for (element of response.data) {
            if (element.approvals !== '2') {
              this.holydasy.push(
                [
                  element.id,
                  this.getFecha(new Date(element.timeOffStartDate.timestamp * 1000)),
                  this.shorTime(element.hrTimeOffStartDate),
                  this.getFecha(new Date(element.returnToWorkDate.timestamp * 1000)),
                  this.shorTime(element.hrReturnToWorkDate),
                  element.reasonforLeave,
                  element.approvals
                ]
              );
            }
          }
          this.loadingHd = false;
        } else {
          this.loadingHd = false;
          this.mtds.notifyError(response.msg, response.code);
        }
        this.loadingHd = false;
      }, error => {
        this.loadingHd = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );

  }

  public hdID = null;

  boton(e) {
    console.log(e);
    switch (e.evento) {
      case 'show': {
        this.hdID = e.row[0];
        this.hdStart = e.row[2];
        this.hdEnd = e.row[3];
        this.hdComments = e.row[4];
        this.openHD('read');
        break;
      }
      case 'delete': {
        this.hdID = e.row[0];
        this.openHD('delete');
        break;
      }
    }
  }

  openHD(action = 'create') {
    $('#hdModal').modal('show');
    this.action = action;
  }

  endHD() {
    $('#hdModal').modal('hide');
    this.hdID = null;
    this.action = 'create';
    this.hdStart = '';
    this.hdEnd = '';
    this.hdComments = '';
    this.hdAvailability = true;
    this.guardando = false;
    this.cargando = false;
  }

  saveHD() {
    this.guardando = true;
    let json;
    json = {
      user_id: this.idUser,
      TypeCheck: 'HOLIDAY',
      holidayStartDate: this.hdStart,
      holidayEndDate: this.hdEnd,
      comments: this.hdComments
    };

    switch (this.action) {
      case 'create': {
        this._hdServices.create(json).subscribe(
          response => {
            if (response.code === 400 && response.msg === 'Authorization not valid') {
              this.mtds.notifyError('Your session has expired');
              localStorage.clear();
              this._router.navigate(['/pages/lock']);
            } else if (response.status === 'success') {
              this.endHD();
              swal.fire({
            
                title: 'Holiday added successfully!',
                text: '',
                buttonsStyling: false,
               customClass:{
    confirmButton: 'btn btn-success'
            },
              });
            } else {
              this.guardando = false;
              this.mtds.notifyError(response.msg, response.code);
            }
          }, error => {
            this.guardando = false;
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
        break;
      }
      case 'update': {
        this._hdServices.update(json, this.hdID).subscribe(
          response => {
            if (response.code === 400 && response.msg === 'Authorization not valid') {
              this.mtds.notifyError('Your session has expired');
              localStorage.clear();
              this._router.navigate(['/pages/lock']);
            } else if (response.status === 'success') {
              this.endHD();
              this.getHolydays();
              swal.fire({
           
                title: 'Holiday updated successfully!',
                text: '',
                buttonsStyling: false,
               customClass:{
    confirmButton: 'btn btn-success'
            },
              });
            } else {
              this.guardando = false;
              this.mtds.notifyError(response.msg, response.code);
            }
          }, error => {
            this.guardando = false;
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
        break;
      }
      case 'delete': {
        this._hdServices.delete(this.hdID).subscribe(
          response => {
            if (response.code === 400 && response.msg === 'Authorization not valid') {
              this.mtds.notifyError('Your session has expired');
              localStorage.clear();
              this._router.navigate(['/pages/lock']);
            } else if (response.status === 'success') {
              this.endHD();
              this.getHolydays();
              swal.fire({
              
                title: 'Holiday has ben remove successfully!',
                text: '',
                buttonsStyling: false,
            customClass:{
    confirmButton: 'btn btn-success'
            },
              });
            } else {
              this.guardando = false;
              this.mtds.notifyError(response.msg, response.code);
            }
          }, error => {
            this.guardando = false;
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
        break;
      }
    }

  }

  validhd(f) {
    if (!f.valid) return false;
    if (this.holydays.reasonforLeave === '') return false;
    if (this.holydays.timeOffStartDate > this.holydays.returnToWorkDate) return false;
    if (this.holydays.timeOffStartDate === this.holydays.returnToWorkDate && this.holydays.hrTimeOffStartDate > this.holydays.hrReturnToWorkDate) return false;
    if (this.statusHolyday.status != 'success') return false;
    if (this.savingHd) return false;

    return true;
  }

  saveHd() {
    console.log(this.holydays);
    this.savingHd = true;
    this._hdServices.create(this.holydays).subscribe(
      response => {
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          this.msgeSwal('success', 'The holidays have been added!');
          this.closeFormModal();
          this.getHolydays();
        } else {
          this.msgeSwal('error', 'Something went wrong');
        }
        this.savingHd = false;
      }, error => {
        this.msgeSwal('error', 'Something went wrong');
        this.savingHd = false;
      }
    );
  }

  checkedAll(category_id) {
    for (let itemCat of this.allCategories) {
      if (!this.isAdded(itemCat.id) && itemCat.father === category_id) {
        return false;
      }
    }

    return true;
  }

  disponible() {
    if (this.holydays.timeOffStartDate !== '' && this.holydays.returnToWorkDate !== ''
      && (this.holydays.timeOffStartDate < this.holydays.returnToWorkDate ||
        (this.holydays.timeOffStartDate === this.holydays.returnToWorkDate
          && this.holydays.hrTimeOffStartDate < this.holydays.hrReturnToWorkDate))) {
      let json;
      json = {
        timeOffStartDate: this.holydays.timeOffStartDate,
        returnToWorkDate: this.holydays.returnToWorkDate,
        hrTimeOffStartDate: this.holydays.hrTimeOffStartDate,
        hrReturnToWorkDate: this.holydays.hrReturnToWorkDate
      };

      this.statusHolyday = null;

      this._hdServices.availability(json, this.idUser).subscribe(
        response => {
          console.log(response);
          this.statusHolyday = response;
        }
      );
    } else {
      this.statusHolyday = null;
    }
  }

  valid(f) {
    if (!f.valid || !this.hdAvailability) {
      return false;
    }

    return true;
  }

  getFecha(fecha: Date) {
    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = '0' + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = '0' + mes;
    } else {
      month = mes;
    }
    let anio = fecha.getFullYear();

    return anio + '-' + month + '-' + day;
  }

  onFileChanged(event) {
    var xhr = new XMLHttpRequest();
    this.selectedFile = <File>event.target.files[0];
    let headers = new Headers({ 'Content-Type': 'multipart/form-data' });

    const uploadData = new FormData();
    uploadData.append('namefile', this.selectedFile, this.selectedFile.name);
    uploadData.append('idpaciente', this.idUser);
    uploadData.append('type', 'PROFILEPIC');
    console.log(uploadData);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          //  console.log(xhr.response);
          let respuesta = JSON.parse(xhr.response);
          console.log(respuesta.status);
          console.log(respuesta.img);
        } else {
          console.log(xhr.response);
        }
      }
    };

    // xhr.open('POST', 'https://www.datalus.mx/projects/liposser/resources/receiver.php', true);
    // xhr.setRequestHeader('Authorization',token);
    xhr.send(uploadData);
  }

  getAllContacts() {
    this._route.params.forEach((params: Params) => {
      let id = + params['id'];

      console.log('contacts');
      console.log(id);
      let enviar = {
        'type': 'VENDOR'
      }
      this._reminderService.getContactsUser(this.token, 1, id, enviar).subscribe(
        response => {
          console.log(response);
          if (response.status == 'success') {
            this.contacts = response.data;
            console.log(response.data);



            this.tableContacts = {
              headerRow: ['ID', 'REP', 'Contact Date', 'Reminder Date', 'Description', 'Actions'],
              dataRows: []
            };

            this.contacts.forEach(function (element) {
              console.log(element);
              console.log('holi');

              let fechaContacto = null;

              if (element.fechacontacto !== null) { fechaContacto = element.fechacontacto.timestamp; }
              this.tableContacts.dataRows.push([
                element.id,
                element.rep.name,
                fechaContacto,
                element.fecha.timestamp,
                element.descripcion
              ]);
            }.bind(this));

          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
      );
    });
  }

  openChangeRep(): void {

    let dialogRef = this.dialog.open(ChangeRep, {
      width: '80%',
      data: { user: this.user, new_user: 0 }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result.new_user != 0) {
        result.new_user = result.new_user.value;
        result.user = result.user.id;
        this._userService.changerep(this.token, result).subscribe(
          response => {
            if (response.status == 'success') {
              //this._router.navigate(['/']);
              // this.getAllPacientes();
              alert("Done");
            } else {
              alert("Error");
            }
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    });
  }


  openDelegate(): void {

    let dialogRef = this.dialog.open(DelegateClients, {
      width: '70%',
      data: { user: this.user, new_user: 0 }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result.new_user != 0) {
        result.new_user = result.new_user.value;
        result.user = result.user.id;
        this._userService.delegate(this.token, result).subscribe(
          response => {
            if (response.status == 'success') {
              //this._router.navigate(['/']);
              // this.getAllPacientes();
              this.showToast('success', 'Clients were delegated correctly', 2000)
            } else {
              this.showToast('error', 'an error occurred', 2000)
            }
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    });
  }

  openDialog(): void {

    let dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: '80%',
      data: { user: this.user }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAllContacts();
    });
  }

  deleteUser() {
    let id = $("#borrarUser").val();
    console.log(id + "aqui");
    this._reminderService.deleteContact(this.token, id).subscribe(
      response => {
        if (response.status == 'success') {
          //this._router.navigate(['/']);
          // this.getAllPacientes();
          alert("Done");
        } else {
          alert("No se ha borrado el usuario");
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  deleteFolderfirst(folder) {
    var txt;
    var r = confirm("Are you sure to delete this registry?");
    if (r == true) {
      $("#contacthistoryregistry" + folder).hide();
      $("#borrarUser").val(folder);

      $("#borrarUser").trigger("click");
    } else {

    }
  }

  ngAfterViewInit() {
    if(this.user.locationId == null){
      this.user.locationId  = 1
    }
    this.activos = this.user.activo;
    this.optionSelectMenuTrigger = this.activos === 1 ? 'Active' : 'Inactive';
   this.rating = this.user.customerPricing;
   this.ratingResponse = this.user.customerResponseTime;
   this.ratingPayment = this.user.customerPaymentOnTime;
   this.ratingeasy = this.user.customerEasyToWorkWith;
    this.GetRep();
    var self = this; // get a reference to `this`

    $('#datatables1').DataTable({
      dom: 'Bflrtip',
      buttons: [
        /*{
          extend: 'copy',
          exportOptions: {
            columns: ':visible'
          }
        },*//*
        {
          extend: 'csv',
          exportOptions: {
            columns: ':visible'
          }
        },*/
        {
          extend: 'excel',
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Excel',
          className: 'btn btn-sm btn-outline-success',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'PDF',
          className: 'btn btn-sm btn-outline-danger',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'print',
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: 'print',
          className: 'btn btn-sm btn-outline-primary',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'colvis',
          text: '<i class="fa fa-columns" aria-hidden="true"></i>',
          className: 'btn btn-sm btn-outline-info',
          titleAttr: 'Column visibility'
        },
      ],
      "pagingType": "full_numbers",
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search",
      }

    });

    const table1 = $('#datatables1').DataTable();

    // Edit record
    table1.on('click', '.edit', function (e) {
      e.preventDefault();
      const $tr = $(this).closest('tr');

      const data = table1.row($tr).data();
      console.log('You press on Row: ' + data[0] + ' ' + data[1] + ' ' + data[2] + '\'s row.');
      //push(self.idPaciente);
      //self.openRegistroVisitas(data);
    });

    // Delete a record
    /*table1.on('click', '.remove', function(e) {
      const $tr = $(this).closest('tr');
      const data = table1.row($tr).data();
     
      table1.row($tr).remove().draw();
      self.deleteContactyHistory(data);
      e.preventDefault();
    });*/

    //Delete a record
    table1.on('click', '.remove', function (e) {
      e.preventDefault();

      var txt;
      var r = confirm("Are you sure to delete this registry?");
      if (r == true) {
        const $tr = $(this).closest('tr');
        const data = table1.row($tr).data();

        table1.row($tr).remove().draw();
        $("#borrarUser").val(data[0]);

        $("#borrarUser").trigger("click");
      } else {

      }
    });

    //Like record
    table1.on('click', '.like', function () {
      alert('You clicked on Like button');
    });
    $('.card .material-datatables label').addClass('form-group');
  }

  animal: string = 'Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium.'
    + 'Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugia';
  name: string;
  bugadmin(event: MatCheckboxChange){
    this.user.bugTicketNotify = event.checked ? 1 : 0;
  }
  onSubmit() {
    console.log(this.user);
    let enviarUser = this.user;

   
    enviarUser.companyLinked = {
      id: this.companySelected
    };
    if (this.user.role == 'VENDOR' || this.user.role == 'customer') {
      if(this.user.locationId == 1){
        this.user.locationId = null
      }
      enviarUser.location = {
        id: this.user.locationId
      };
    }
    enviarUser.term = {
      id: this.termSelected
    };
    enviarUser.condition = {
      id: this.conditionSelected
    };
    enviarUser.currency = {
      id: this.currencySelected
    };

    enviarUser.joinToWork = this.getFecha(new Date(enviarUser.joinToWork));
    this._userService.update_user_remoto(enviarUser).subscribe(
      response => {
        console.log(response);
        this.status_user = response.status;
        console.log(this.status_user);
        if (this.status_user != 'success') {
          this.status_user = 'error';
        } else {
          let data = {
            user_id: this.user.id,
            category_id: JSON.stringify(this.userCategories)
          };
          console.log('Datalus: ');
          console.log(data);
          this.user = response.user;
          this.availablePaidHours = parseInt(this.user.holidayHours) - parseInt(this.user.horasPagadasUsadas);
           this.showToast('success', 'Saved!', 2000) 
         const currentUrl = this._router.url;
         this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
           this._router.navigate([currentUrl]);
         });
          this._cattegorieServices.updateUserCategories(data, this.user.id).subscribe(
            respuesta => {
              if (respuesta.status === 'success') {
                console.log('Categorias Actualizadas Exitosamente!');
              } else {
                console.log('Error al actualizar categorias!');
              }
            }, error => {
              console.log('Error al actualizar categorias!');
            }
          );
          this.user = response.user;
          // this._router.navigate(['/task', this.task.id]);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  getCompanies() {
    this._companylinkedService.getAllCompaniesLite(this.token, 'all').subscribe(
      response => {
        // console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status == 'success') {
          this.companies = response.data;
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  getCategories() {
    this._cattegorieServices.showAll().subscribe(
      response => {
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          this.allCategories = response.data;
          for (let item of response.data) {
            if (item.father === 0) {
              let padre = {
                id: item.id,
                father: item.father,
                name: item.name,
                sub: []
              };
              this.categories.push(padre);
            }
          }

          for (let item of response.data) {
            if (item.father !== 0) {
              let hijo = {
                id: item.id,
                father: item.father,
                name: item.name
              };
              for (let i of this.categories) {
                if (i.id === hijo.father) {
                  i.sub.push(hijo);
                  break;
                }
              }
            }
          }
          // console.log('Aquie merengues');
          // console.log(this.categories);
        } else {
          console.log('Error!');
        }
      }, error => {
        console.log('Error!');
      }
    );
  }

  addCategoire(category, evento) {
    if (category.name !== 'All') {
      if (!evento.checked) {
        let index = 0;
        for (let item of this.userCategories) {
          if (item === category.id) {
            this.userCategories.splice(index, 1);
          }
          index++;
        }
        console.log(category.father);
        if (category.father === 0) {
          for (let itemCat of this.allCategories) {
            if (this.isAdded(itemCat.id) && itemCat.father === category.id) {
              let index = 0;
              for (let i of this.userCategories) {
                if (itemCat.id === i) {
                  this.userCategories.splice(index, 1);
                  break;
                }
                index++;
              }
            }
          }
        }
      } else {
        this.userCategories.push(category.id);
      }
    } else if (category.name === 'All' && !evento.checked) {
      for (let itemCat of this.allCategories) {
        if (this.isAdded(itemCat.id) && itemCat.father === category.father) {
          let index = 0;
          for (let i of this.userCategories) {
            if (itemCat.id === i) {
              this.userCategories.splice(index, 1);
              break;
            }
            index++;
          }
        }
      }
    } else if (category.name === 'All' && evento.checked) {
      for (let itemCat of this.allCategories) {
        if (!this.isAdded(itemCat.id) && itemCat.father === category.father) {
          this.userCategories.push(itemCat.id);
        }
      }
    }

    console.log(this.userCategories);
  }

  isCheked(category) {
    if (category.name === 'All') {
      return this.checkAll(category);
    } else {
      return this.isAdded(category.id);
    }
  }

  checkAll(category) {
    for (let item of this.categories) {
      if (item.id === category.father) {
        for (let i of item.sub) {
          if (!this.isAdded(i.id)) {
            return false;
          }
        }
        return true;
      }
    }
  }

  isAdded(id) {
    for (let i of this.userCategories) {
      if (id === i) {
        return true;
      }
    }
    return false;
  }

  getUserCategories(id) {
    this._cattegorieServices.getUserCategories(id).subscribe(
      response => {
        this.userCategories = response.data;
      }
    );
  }

  sendWelcomeEmail(){

    let me = this;

    swal.fire({
        title: 'Are you sure?',
        text: 'We will send a welcome email to the user',
      
        showCancelButton: true,
       
        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        confirmButtonText: 'Yes, send it!',
        buttonsStyling: false
      }).then(function (respuesta_user) {
        if(respuesta_user.value){
         
        me._userService.sendwelcomeemail(me.token, me.user.id).subscribe(
        response => {
          console.log("respuesta welcome email => ", response);
          if (response.code === 400 && response.msg === 'Authorization not valid') {
            me.mtds.notifyError('Your session has expired');
            localStorage.clear();
            me._router.navigate(['/pages/lock']);
          } else if (response.status == 'success') {

            me.getUser();

            swal.fire({
          title: 'Email Sent!',
          text: 'Email sent, a new password has been generated.',
        
       customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false
        });
          }
        }, error => {
          
          me.mtds.notifyError(error.statusText, error.status);
        }
      );
        }
        

        
      });

      
    
  }

  getUser() {
    let me = this;
    this.loading = 'show';
    this._route.params.forEach((params: Params) => {
      let id = + params['id'];
      console.log(id);
      this._userService.getUser(this.token, id).subscribe(
        response => {
          console.log('Usuario: ');
          console.log(response);

          if (response.code === 400 && response.msg === 'Authorization not valid') {
            this.mtds.notifyError('Your session has expired');
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          } else if (response.status == 'success') {

            this.user = response.data;
            this.mobiletempo = response.data.mobilePhone;
            this.getCompanyLocations(this.user.companyLinked.id);

            this.welcomeSent = response.data.welcomeSent;

            if (this.user.holidayHours == null)
              this.user.holidayHours = 0;

            if (this.user.horasPagadasUsadas == null)
              this.user.horasPagadasUsadas = 0;

            if (this.user.horasNoPagadasUsadas == null)
              this.user.horasNoPagadasUsadas = 0;

            if (this.user.location == null) {
              this.user.location = {};
              this.user.location.id = 0;
            }

            if (!this.user.typeLocationSelected) {
              if (this.user.locationId === 1 || this.user.locationId === 208) {
                this.user.typeLocationSelected = 'Headquarter';
              } else if (this.user.locationId === 0) {
                this.user.typeLocationSelected = 'Blank';
              } else {
                this.user.typeLocationSelected = 'Location';
              }
            }

            const date = new Date(this.user.joinToWork);
            date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
            this.user.joinToWork = date;

            const date2 = new Date(this.user.birthDate);
            date2.setMinutes(date2.getMinutes() + date2.getTimezoneOffset());
            this.user.birthDate = date2;

            console.log(this.user.location);

            this.user.holidayHours = parseInt(this.user.holidayHours);
            this.user.horasPagadasUsadas = parseInt(this.user.horasPagadasUsadas);
            this.user.horasNoPagadasUsadas = parseInt(this.user.horasNoPagadasUsadas);

        
           if (response.data.createdAt) {
            this.user.created_at = response.data.createdAt.substring(0, 10);
          } else {
            this.user.created_at = ''; 
          }
            this.totalUsedHours = parseInt(this.user.horasPagadasUsadas) + parseInt(this.user.horasNoPagadasUsadas);

            this.availablePaidHours = parseInt(this.user.holidayHours) - parseInt(this.user.horasPagadasUsadas);
            console.log(this.availablePaidHours);
            if (this.user.role === 'customer') {
              this.getCategories();
              this.getUserCategories(this.user.id);
            }

            console.log(this.user.enableAsDriver);
            if (this.user.companyLinked == null) {
              console.log('no hay company');
              this.user.companyLinked['id'] = 0;
            } else {
              this.companySelected = this.user.companyLinked.id;
            }

            if (this.user.location == null) {
              console.log('no hay location');
              this.user.location['id'] = 0;
            } else {
              this.locationSelected = this.user.location.id;
            }

            if (this.user.term == null) {
              console.log('no hay term');
              this.user.term['id'] = 0;
            } else {
              this.termSelected = this.user.term.id;
            }

            if (this.user.condition == null) {
              console.log('no hay condition');
              this.user.condition['id'] = 0;
            } else {
              this.conditionSelected = this.user.condition.id;
            }

            if (this.user.currency == null) {
              console.log('no hay currency');
              this.user.currency['id'] = 0;
            } else {
              this.currencySelected = this.user.currency.id;
            }

            this.loading = 'hide';
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
        },
        error => {
          console.log(<any>error);
        }
      );
      this._tagServices.listTagsByUser(id).subscribe(
        response => {
          console.log(response);
          if (response.code === 400 && response.msg === 'Authorization not valid') {
            this.mtds.notifyError('Your session has expired');
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          } else if (response.status === 'success') {
            this.usersTags = [];
            for (let item of response.data) {
              let data = {
                id: item.id,
                name: item.userTag.name,
                user: item.user.id,
                tag: item.userTag.id
              };
              this.usersTags.push(data);
            }
          } else {
            this.mtds.notifyError(response.msg, response.code);
          }
        }, error => {
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
    });
  }


  showSwal(type) {
    if (type === 'success-citas') {
      swal.fire({
    
        title: 'Cita agendada con éxito!',
        text: 'Has agendando una nueva cita.',
        buttonsStyling: false,
     customClass:{
    confirmButton: 'btn btn-success'
            },

      });

    } else if (type === 'success-message') {
      swal.fire({
      
        title: 'Paciente guardado con éxito!',
        text: 'Has guardado un nuevo paciente.',
        buttonsStyling: false,
       customClass:{
    confirmButton: 'btn btn-success'
            },

      });

    } else if (type === 'warning-message-and-confirmation') {
      swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to revert this!',
      
        showCancelButton: true,
    
        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(function () {
        swal.fire({
          title: 'Deleted!',
          text: 'Your file has been deleted.',
      
        customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false
        });
      });
    } else if (type === 'warning-message-and-cancel') {
      swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this imaginary file!',
     
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
       

        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        buttonsStyling: false
      }).then(function () {
        swal.fire({
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
        
        customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false
        });
      }, function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          swal.fire({
            title: 'Cancelled',
            text: 'Your imaginary file is safe :)',
          
          customClass:{
    confirmButton: 'btn btn-info'
            },
            buttonsStyling: false
          });
        }
      });
    } else if (type === 'custom-html') {
      swal.fire({
        title: 'HTML example',
        buttonsStyling: false,
      customClass:{
    confirmButton: 'btn btn-success'
            },
        html:
          'You can use <b>bold text</b>, ' +
          '<a href="http://github.com">links</a> ' +
          'and other HTML tags'
      });

    } else if (type === 'auto-close') {
      swal.fire({
        title: 'Auto close alert!',
        text: 'I will close in 2 seconds.',
        timer: 2000,
        showConfirmButton: false
      }).then(
        function () { },
        // handling the promise rejection
        function (dismiss) {
          if (dismiss === 'timer') {
            console.log('I was closed by the timer')
          }
        });
    } else if (type === 'input-field') {
      swal.fire({
        title: 'Input something',
        html: '<div class="form-group">' +
          '<input id="input-field" type="text" class="form-control" />' +
          '</div>',
        showCancelButton: true,
       
        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        buttonsStyling: false
      }).then(function (result) {
        swal.fire({
      
          html: 'You entered: <strong>' +
            $('#input-field').val() +
            '</strong>',
        customClass:{
    confirmButton: 'btn btn-success'
            },
          buttonsStyling: false

        });
      });
    }


  }



}

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog-overview-example-dialog.html',
  providers: [ContactHistoryService, UserService, ReminderService, ContactsFormService]
})
export class DialogOverviewExampleDialog {
  public mtds: Methods = new Methods();
  public userinterno;
  public identity;
  public token;
  public contacthistory: Reminder;
  public status_contactHistory;
  public status_user;

  public idcontact;

  public statusLead;

  types = [
    { value: 'CALL', viewValue: 'Call' },
    { value: 'E-MAIL', viewValue: 'E-mail' },
  ];

  constructor(
    private _ContactFormService: ContactsFormService,
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _contactHistoryService: ContactHistoryService,
    private _reminderService: ReminderService,
    private _route: ActivatedRoute,
    private _router: Router) {
    console.log(data.user);
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.userinterno = data.user;
  }

  showSwal(type) {
    if (type === 'success-contactHistory') {
      swal.fire({
       
        title: 'Contact form has been saved successfully',
        text: '',
        buttonsStyling: false,
       customClass:{
    confirmButton: 'btn btn-success'
            },

      });

    }
  }

  addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  ngOnInit() {

    var today = new Date();
    var date = today.getFullYear() + '-' + (this.addZero(today.getMonth()) + 1) + '-' + this.addZero(today.getDate());
    var time = this.addZero(today.getHours()) + ":" + this.addZero(today.getMinutes()) + ":" + this.addZero(today.getSeconds());
    console.log(date);
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(['/pages/lock']);
    } else {
      this.contacthistory = new Reminder(1, this.userinterno.id, this.userinterno.managedBy, '', '', date, time, '', 'VENDOR', '', 0, 0, '', '');
    }
  }


  setranking(value) {

    let enviar = {
      "rank": value
    }

    this._ContactFormService.setranking(this.token, this.idcontact, enviar).subscribe(
      response => {
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status == 'success') {
          alert("Done");
          this.statusLead = response.data.ranking;
        } else {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        }
      },
      error => {
        console.log(<any>error);
      }
    );

  }



  onSubmit() {
    console.log("enviamos");
    console.log(this.contacthistory);
    this._reminderService.create(this.token, this.contacthistory, this.contacthistory).subscribe(
      response => {
        console.log(response);
        this.status_contactHistory = response.status;

        if (this.status_contactHistory != 'success') {
          this.status_contactHistory = 'error';
        } else {
          this.showSwal('success-contactHistory');
          this.contacthistory = response.data;
          console.log(response.data);
          //this._router.navigate(['/task', this.task.id]);
          this.dialogRef.close();

          return response.data;
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }


  onNoClick(): void {

  }

  close() {
    this.dialogRef.close();
  }

}


@Component({
  selector: 'change-rep',
  templateUrl: 'change-rep.html',
  providers: [UserService]
})
export class ChangeRep implements OnInit, AfterViewInit {
  public userinterno;
  public loading: boolean = false;
  public identity;
  public token;
  public user;
  public status_user;
  public privilegio;
  public pacientes;
  public folder;
  public productosResponse;
  public user_new;
  myControl = new FormControl();
  myControlClientes = new FormControl();

  public permissionsShow;


  clientes: UserList[] = [

  ];


  filteredClientes: Observable<UserList[]>;


  constructor(
    public dialogRef: MatDialogRef<ChangeRep>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _userService: UserService,
    private _route: ActivatedRoute,
    private _router: Router) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.user = data;
    console.log(this.user.user.name);
    console.log(this.user);
    this.loading = true;

    this._userService.getAllUsers(this.token).subscribe(
      response => {
        console.log(response);
        if (response.status == 'success') {
          this.loading = false;
          this.pacientes = response.data;
          console.log(this.pacientes);




        } else {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);

        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  ngOnInit() {
    console.log("5555");
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(['/pages/lock']);
    } else {

    }



    this.getListUsers("exceptuser");

    this.filteredClientes = this.myControlClientes.valueChanges
      .pipe(
        startWith<string | UserList>(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filterClientes(name) : this.clientes.slice())
      );

    console.log(this.filteredClientes);
    console.log(this.clientes);

  }

  ngAfterViewInit() {



  }

  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

  private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.clientes.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  getListUsers(type) {



    this.loading = true;
    this._userService.getAllUsersLite(this.token, type).subscribe(
      response => {
        console.log("lite");
        console.log(response);
        this.loading = false;
        if (response.status == 'success') {

          console.log('usuarios '+response.data);
          if (type != 'VENDOR') {
            response.data.forEach(function (element) {

              this.clientes.push({ value: element.id, name: element.name + ' ' + element.surname + ' # ' + element.id });

            }.bind(this));
          }
        } else {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);

        }
      },
      error => {
        console.log(<any>error);
      }
    );



  }


  selectPacient(event) {
    //console.log(event.value);


    this._userService.getUser(this.token, event.value).subscribe(
      response => {

        if (response.status == 'success') {

          this.userinterno = response.data;
          console.log(this.userinterno);
          this.folder.user_id = this.userinterno.id;

        }
      },
      error => {
        console.log(<any>error);
      }
    );


  }




}

@Component({
  selector: 'delegate-client',
  templateUrl: 'delegate-client.html',
  styleUrls: ['./delegate-client.css'],
  providers: [UserService]
})
export class DelegateClients implements OnInit, AfterViewInit {
  public userinterno;
  public loading: boolean = false;
  public identity;
  public token;
  public user;
  public status_user;
  public privilegio;
  public pacientes;
  public folder;
  public productosResponse;
  public user_new;
  myControl = new FormControl();
  myControlClientes = new FormControl();

  public permissionsShow;

  public name;
  clientes: UserList[] = [

  ];


  filteredClientes: Observable<UserList[]>;


  constructor(
    public dialogRef: MatDialogRef<DelegateClients>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _userService: UserService,
    private _route: ActivatedRoute,
    private _router: Router) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.user = data;
    console.log(this.user.user.name);
    console.log(this.user);
    this.loading = true;

    this._userService.getAllUsers(this.token).subscribe(
      response => {
        console.log(response);
        if (response.status == 'success') {
          this.loading = false;
          this.pacientes = response.data;
          console.log(this.pacientes);




        } else {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);

        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  cerrar(){
    this.dialogRef.close();
  }
  ngOnInit() {
    this.name = this.user.user.name + this.user.user.surname;
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(['/pages/lock']);
    } else { 

    }



    this.getListUsers("worker");

    this.filteredClientes = this.myControlClientes.valueChanges
      .pipe(
        startWith<string | UserList>(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filterClientes(name) : this.clientes.slice())
      );

    console.log(this.filteredClientes);
    console.log(this.clientes);

  }

  ngAfterViewInit() {



  }

  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

  private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.clientes.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  getListUsers(type) {



    this.loading = true;
    this._userService.getAllUsersLite(this.token, type).subscribe(
      response => {
        console.log("lite");
       
        this.loading = false;
        if (response.status == 'success') {
          console.log('users list ',response);

          if (type == 'worker') {
            response.data.forEach(function (element) {

              this.clientes.push({ value: element.id, name: element.name + ' ' + element.surname + ' # ' + element.id });

            }.bind(this));
          }
        } else {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);

        }
      },
      error => {
        console.log(<any>error);
      }
    );



  }


  selectPacient(event) {


    this._userService.getUser(this.token, event.value).subscribe(
      response => {

        if (response.status == 'success') {

          this.userinterno = response.data;
          console.log(this.userinterno);
          this.folder.user_id = this.userinterno.id;

        }
      },
      error => {
        console.log(<any>error);
      }
    );


  }




}

//
@Component({
  selector: 'UserChangePasswordComponent',
  templateUrl: 'userchangepassword.component.html',
  providers: [UserService
  
  ]
})

export class UserChangePasswordComponent implements OnInit, AfterViewInit {

public identity;
public token;
public privilegio;

 public loading;

 public idPaciente;

 //public user: User;
 public user;

public pages;
public pagePrev;
public pageNext;
public filter = 0;
public order = 0;
public searchString;
public status_user;
password2: string = '';
password1: string = '';
hide = true;
hide1 = true;


   constructor(public dialogRef: MatDialogRef<UserChangePasswordComponent>,@Inject(MAT_DIALOG_DATA) public data: any,public dialog: MatDialog, private _userService: UserService, 
   
    private _route: ActivatedRoute,
    private _router: Router) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
  this.identity = this._userService.getIdentity();
  this.token = this._userService.getToken();

console.log(this.identity);

//this.user = this.identity;
   // this.showSwal('welcome');
/* this.user = {
    name: "loading",
    surname: '...'
  } */
}
closeDialog(): void {
  this.dialogRef.close();
}
   ngOnInit() {
    console.log("beetweend")
    console.log(this.data)
    console.log(this.data.userid.id)
    console.log("entre")
    this.getUser();
   if(this.identity == null && this.identity.sub){
    localStorage.clear();
  /*   this._router.navigate(['/pages/lock']); */
  } else {
    
this.getUser();
}


 }



   ngAfterViewInit() {

var self = this; // get a reference to `this`

    

  }
  cerrar(){
    this.dialogRef.close();
  }

onSubmit(){
  this.user.password = this.password1;
  console.log(this.user);
  this._userService.chPassword(this.user).subscribe(
      response => {
        console.log(response);
        this.status_user = response.status;
        console.log(this.status_user);
        if(this.status_user != 'success'){
          this.status_user = 'error';
        } else {
          this.user = response.user;
          this.showToast('success', 'the password was changed correctly', 2000)
          this.dialogRef.close();
          //this._router.navigate(['/tables/listfiles']);
       
         
        }
      },
      error => {
        console.log(<any>error);
      }
    );
}

 


getUser(){
  this.loading = 'show';
 
    let id = this.data.userid.id;
   

    this._userService.getUser(this.token, id).subscribe(
      response => {
        
        if(response.status == 'success'){
          console.log(this.user)
            this.user = response.data;
            this.loading = 'hide';

          
        } else {
          localStorage.clear();
          /* this._router.navigate(['/pages/lock']); */
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  
}


showSwal(type) {
    if (type === 'success-changed') {
          swal.fire({
            
              title: 'Password has been changed!',
              text: ' password has been changed.',
              buttonsStyling: false,
           
              customClass:{
  confirmButton: 'btn btn-success'
          },

          });

      } else  if (type === 'welcome') {
          swal.fire({
         
              title: 'Welcome to GreenTek Solutions, LLC Dashboard',
              text: 'Please change your password',
              buttonsStyling: false,
             customClass:{
  confirmButton: 'btn btn-success'
          },

          });

      } 
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }




}
//
@Component({
  selector: 'ContactHistoryComponent',
  templateUrl: 'Contact-history.html',
  providers: [UserService,ReminderService
  
  ]
})

export class ContactHistoryComponent implements OnInit, AfterViewInit {
//
public userinterno;
public contacts: DinamicData = new DinamicData(
  ['ID','REP','Contact Date','Reminder Date','Description', 'Actions']
)
activeTabIndex = 0; 
public filtros = [];
public mtds: Methods = new Methods();
public campoBusqueda = "";
public paginaActual = 1;
public itemsPorPagina = "10";
public totalItems = 0;
public totalPaginas = 1;
public options: Array<any> = [];
public editHistory = false;
public saveEditHistory = false;
public contacthistory: Reminder;
public editContact = true;
public saveContact = false;
public btns = false;
public idcontact;
public showAddPeopleToReminder = false;
myControlUsers = new FormControl();
filteredArrayUsers: Observable<UserList[]>;
public arrayUsers: any[] = [];
public usersList: any[] = [];
public usersSeleccionados = [];
//
public identity;
public token;
public privilegio;

public loading = false;
public status_contactHistory;
 public idPaciente;

 //public user: User;
 public user;

public pages;
public pagePrev;
public pageNext;
public filter = 0;
public order = 0;
public searchString;
public status_user;
password2: string = '';
password1: string = '';
hide = true;
hide1 = true;


   constructor(public dialogRef: MatDialogRef<ContactHistoryComponent>,@Inject(MAT_DIALOG_DATA) public data: any,public dialog: MatDialog, private _userService: UserService, private _reminderService: ReminderService, private _config: ConfigService,
   
    private _route: ActivatedRoute,
    private _router: Router) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
  this.identity = this._userService.getIdentity();
  this.token = this._userService.getToken();
 this.idcontact = data.userid.id
  this.getAllContacts();
  this.getUser();
  this.getUsers();
  this.userinterno = data.userid;
console.log(this.identity);

//this.user = this.identity;
   // this.showSwal('welcome');
/* this.user = {
    name: "loading",
    surname: '...'
  } */
}
showFormContactHistory=false;
titleFormContactHistory;
showFormContactH(type){
  if(type=== 'Edit'){
    this.showFormContactHistory = true;

  }else{
    this.showFormContactHistory = !this.showFormContactHistory;

  }
  this.titleFormContactHistory = type;
}
//
addZero(i) {
  if (i < 10) {
    i = "0" + i;
  }
  return i;
}
cleanContact() {
  let today = new Date();
  let date =
    today.getFullYear() +
    "-" +
    (this.addZero(today.getMonth()) + 1) +
    "-" +
    this.addZero(today.getDate());
  let time =
    this.addZero(today.getHours()) +
    ":" +
    this.addZero(today.getMinutes()) +
    ":" +
    this.addZero(today.getSeconds());
  this.contacthistory = new Reminder(
    1,
    this.idcontact,
    this.identity.sub,
    "",
    "",
    today,
    time,
    "",
    'VENDOR',
    "",
    0,
    0,
    "",
    ""
  );
  this.editHistory = false;
  this.showFormContactH('New');
}

setDate(fecha, hora) {
  let fechaContacto;
  let arrayhr = hora.split(":");
  let seconds = +arrayhr[0] * 60 * 60 + +arrayhr[1] * 60;
  seconds = seconds * 1000;
  fechaContacto = fecha.timestamp * 1000;
  fechaContacto = fechaContacto + seconds;
  fechaContacto = this.mtds.getFecha(new Date(fechaContacto), "MM-dd-yyyy");
  console.log(fechaContacto);
  return fechaContacto;
}
convertDate(date, format) {
  let dateSplitted = date.split("-");
  let year;
  let month;
  let day;
  if (format == "mm-dd-yyyy") {
    year = dateSplitted[0];
    month = dateSplitted[1];
    day = dateSplitted[2];
    return `${month}-${day}-${year}T00:00:00`;
  } else if (format == "yyyy-mm-dd") {
    month = dateSplitted[0];
    day = dateSplitted[1];
    year = dateSplitted[2];
    return `${year}-${month}-${day}T00:00:00`;
  }
}
/* getAllContacts() {
  this._route.params.forEach((params: Params) => {
    let id = + params['id'];

    console.log('contacts');
    console.log(id);
    let enviar = {
      'type': 'VENDOR'
    }
    this._reminderService.getContactsUser(this.token, 1, id, enviar).subscribe(
      response => {
        console.log(response);
        if (response.status == 'success') {
          this.contacts = response.data;
          console.log(response.data);



          this.tableContacts = {
            headerRow: ['ID', 'REP', 'Contact Date', 'Reminder Date', 'Description', 'Actions'],
            dataRows: []
          };

          this.contacts.forEach(function (element) {
            console.log(element);
            console.log('holi');

            let fechaContacto = null;

            if (element.fechacontacto !== null) { fechaContacto = element.fechacontacto.timestamp; }
            this.tableContacts.dataRows.push([
              element.id,
              element.rep.name,
              fechaContacto,
              element.fecha.timestamp,
              element.descripcion
            ]);
          }.bind(this));

        } else {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);

        }
      },
      error => {
        console.log(<any>error);
      }
    );
  });
} */
getAllContacts(e = null, newfilter = true) {
  this.loading = true;
  let enviar = {
    'type': 'VENDOR'
  }
  this._reminderService
    .getContactsUser(
      this.token, 1,this.data.userid.id,enviar)
     .subscribe(
      (response) => {
        
        if (response.status == "success") {
          
          this.paginaActual = Number(response.page_actual);
          this.itemsPorPagina = String(response.items_per_page);
          this.totalItems = Number(response.total_items_count);
          this.totalPaginas = Number(response.total_pages);

           if (newfilter) {

            this.filtros = [
              { key: 'filter_id', title: 'ID', value: '', type: 'contains', key_type: 'filter_id_type', type_options: [
                { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
              ] },
              { key: 'filter_rep', title: 'Rep', value: '', type: 'equalto', key_type: 'filter_rep_type', type_options: [
                { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
              ] },
              { key: 'filter_contact_date', title: 'Contact Date', value: '', type: 'startswith', key_type: 'filter_contact_date_type', type_options: [
                { value: 'startswith', name: 'Starts With' }
              ] },
              { key: 'filter_reminder_date', title: 'Reminder Date', value: '', type: 'startswith', key_type: 'filter_reminder_date_type', type_options: [
                { value: 'startswith', name: 'Starts With' }
              ] },
              { key: 'filter_description', title: 'Description', value: '', type: 'contains', key_type: 'filter_description_type', type_options: [
                { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
              ] },
              null
            ];
          }

          this.contacts.rows = [];

          for (let element of response.data) {

            let actionButtons = []

            actionButtons.push({ icon: 'edit', action: 'Edit', color: 'info' },{ icon: 'delete_outline', action: 'Remove', color: 'danger' });              
            let fechac
            let fechaContacto = this.setDate(
              /* fechac = element.fechacontacto !== null ? element.fechacontacto.timestamp : null, */
              element.fechacontacto,
              element.horacontacto
            );
            let fecha = this.setDate(element.fecha, element.hora);

            this.contacts.rows.push(
              [
                new Cell(element.id),
                new Cell(element.rep.name + ' ' + element.rep.surname),
                new Cell(fechaContacto),
                new Cell(fecha !== 'NaN-NaN-NaN' ? fecha : this.mtds.getFecha(new Date(element.fecha.timestamp * 1000), 'MM-dd-yyyy')),
                new Cell(element.descripcion),
                new Cell(actionButtons, {type: 'actions'})
              ]
            );
          }
        } else {
          /*localStorage.clear();
          this._router.navigate(["/pages/lock"]);*/
        }
        this.loading = false;
      },
      (error) => {
        console.log(<any>error);
        this.loading = false;
      }
    );
}
action(e) {
  console.log(e);
  switch (e.action) {
    case "Remove":
      this.deleteContactHistory(e.id);
      break;
    case "Edit":
      this.getContactHistory(e.id);
      break;
    default:
      break;
  }
}
getContactHistory(id) {
  this.editHistory = true;
  this._reminderService.getContact(this.token, id).subscribe((response) => {
    console.log(response, "resp");
    this.contacthistory.id = response.data.id;

    let fechaContacto = this.setDate(
      response.data.fechacontacto,
      response.data.horacontacto
    );
    this.contacthistory.fechacontacto = this.convertDate(
      fechaContacto,
      "yyyy-mm-dd"
    );

    this.contacthistory.horacontacto = response.data.horacontacto;
    this.contacthistory.reminder = response.data.reminder;
    let fecha = this.setDate(response.data.fecha, response.data.hora);
    this.contacthistory.fecha = this.convertDate(fecha, "yyyy-mm-dd");

    this.contacthistory.hora = response.data.hora;
    this.contacthistory.descripcion = response.data.descripcion;
    this.contacthistory.email = response.data.email;
    this.contacthistory.notification = response.data.notification;
  });
  this.showFormContactH('Edit');
}
deleteContactHistory(id) {
  swal
    .fire({
      title: "Delete Contact History",
      text: "Are you sure you want to delete this contact history",

      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-default",
      },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Yes, remove it",
    })
    .then(
      function (result) {
        if (result.value) {
          this._reminderService.deleteContact(this.token, id).subscribe(
            (response) => {
              this.getAllContacts();
            },
            (error) => {
              alert("Something went wrong");
            }
          );
        }
      }.bind(this)
    );
}
updateConfig(e) {
  this.options = e;
  console.log(this.options);
  this._config.setConfig('contactHistory', this.options).subscribe(
    r => {
      console.log(r);
    }
  );
}
//
closeDialog(): void {
  this.dialogRef.close();
}
   ngOnInit() {
    console.log(this.userinterno)
    this.userinterno = this.data.userid
    this.getUser();
    console.log("entre")
    console.log(this.userinterno)
    console.log(this.data)
    console.log("us")
    var today = new Date();
    var date =
      today.getFullYear() +
      "-" +
      (this.addZero(today.getMonth()) + 1) +
      "-" +
      this.addZero(today.getDate());
    var time =
      this.addZero(today.getHours()) +
      ":" +
      this.addZero(today.getMinutes()) +
      ":" +
      this.addZero(today.getSeconds());
   if(this.identity == null && this.identity.sub){
    localStorage.clear();
  /*   this._router.navigate(['/pages/lock']); */
  } else {
    this.contacthistory = new Reminder(
      1,
      this.userinterno.id,
      this.userinterno.managedBy,
      "",
      "",
      today,
      time,
      "",
      'VENDOR',
      "",
      0,
      0,
      "",
      ""
    );
    
this.getUser();
}


 this.filteredArrayUsers = this.myControlUsers.valueChanges.pipe(
          startWith<string | UserList>(""),
          map((value) => (typeof value === "string" ? value : value.name)),
          map((name) => (name ? this._filterUsers(name) : this.arrayUsers.slice()))
        );
    
        this.myControlUsers.valueChanges
          .pipe(
            map((value) => {
              if (
                value === null ||
                value === undefined ||
                value === "" ||
                value === " "
              ) {}
              return value;
            })
          )
          .subscribe();

 }

   private _filterUsers(name: string): UserList[] {
       const filterValue = name.toLowerCase();
   
       return this.arrayUsers.filter((option) =>
         option.name.toLowerCase().includes(filterValue)
       );
 
     }



   ngAfterViewInit() {

var self = this; // get a reference to `this`

    

  }
  cerrar(){
    this.dialogRef.close();
  }

  onSubmit() {
    console.log("enviamos");
    console.log(this.contacthistory);
    let json = {
      users: []
    };

   if( this.contacthistory.reminder == 'YES'){
    json.users.push(this.usersSeleccionados);
   }else{
    json.users.push(this.userinterno.id);
   }

//console.log('contacthistory ',this.contacthistory,' json ',json);

   
    this._reminderService.create(this.token, this.contacthistory, json).subscribe(
      response => {
        console.log(response);
        this.status_contactHistory = response.status;

        if (this.status_contactHistory != 'success') {
          this.status_contactHistory = 'error';
        } else {
          this.showToast('success', 'Contact form has been saved successfully', 2000)

          this.contacthistory = response.data;
          console.log(response.data);
          //this._router.navigate(['/task', this.task.id]);
          this.dialogRef.close();

          return response.data;
        }
      },
      error => {
        console.log(<any>error);
      }
    );


  }

/* onSubmit() {
  console.log("enviamos");
  console.log(this.contacthistory);
  console.log("enviamosnt")
  console.log(this.userinterno.id)
  let json = {
    users: this.userinterno.id,
  };

  this._reminderService
    .create(this.token, this.contacthistory, json)
    .subscribe(
      (response) => {
        console.log(response);
        this.status_contactHistory = response.status;

        if (this.status_contactHistory != "success") {
          this.status_contactHistory = "error";
        } else {
          this.showToast('success', 'Contact form has been saved successfully', 2000)

          this.contacthistory = response.data;
          console.log(response.data);

          this.getAllContacts();
          this.cleanContact()
          return response.data;
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
} */


getUser(){
  this.loading = true;
 
    let id = this.data.userid.id;
   

    this._userService.getUser(this.token, id).subscribe(
      response => {
        
        if(response.status == 'success'){
          console.log('getUser ',this.user)
            this.user = response.data;
            this.loading = false;
            this.userinterno = this.user;
          
        } else {
          localStorage.clear();
          /* this._router.navigate(['/pages/lock']); */
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  
}
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }

  getUsers() {
    this.arrayUsers = [];
    this._userService
      .getAllUsersLite(this._userService.getToken(), "exceptuser")
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.arrayUsers = response.data;
            this.usersList = response.data.map(e => {
              return {id: e.id, name: `${e.name} ${e.surname}`}
            });
          } else {
            alert("Error");
          }
          console.log(this.arrayUsers);
        },
        (error) => {
          console.log(<any>error);
          alert("Error");
        }
      );
  }

  seleccionarUser(id) {
    let numero: number, encontrado: boolean, index: number;
    index = 0;
    encontrado = false;
    for (numero of this.usersSeleccionados) {
      if (numero === id) {
        encontrado = true;
        this.usersSeleccionados.splice(index, 1);
        let json;

        json = {
          type: "DELETEUSER",
          data: numero,
        };

        /*this._notificationService.editNotification(this.token, this.editNotification, json).subscribe(
          response => {
          }
        );*/
        break;
      }
      index++;
    }

    if (!encontrado) {
      this.usersSeleccionados.push(id);
      let json;

      json = {
        type: "ADDUSER",
        data: id,
      };

      /*this._notificationService.editNotification(this.token, this.editNotification, json).subscribe(
          response => {
          }
        );*/
    }
  }

  chequeadoUser(id) {
    let numero: number;
    for (numero of this.usersSeleccionados) {
      if (numero === id) {
        return true;
      }
    }

    return false;
  }


}
